export const urologyConst = {
  path: "/single-programs/urology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – УРОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Урология — точная диагностика и хирургия с заботой о качестве жизни</h2>
      <p>
        Урология — это важнейшее клиническое направление, которое занимается диагностикой, лечением и профилактикой заболеваний
        мочевыделительной системы у мужчин и женщин, а также патологий мужской репродуктивной системы. Эта специальность сочетает в себе
        терапевтические, хирургические и высокотехнологичные подходы к лечению пациентов.
      </p>
      <p>
        Обучение по направлению «Урология» ориентировано на подготовку врачей, владеющих современными методами диагностики, малоинвазивными
        и эндоскопическими техниками, а также навыками ведения пациентов с хроническими и острыми заболеваниями почек, мочевого пузыря,
        предстательной железы и половых органов.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и физиология мочеполовой системы</li>
        <li>Урологические инфекции и воспалительные заболевания</li>
        <li>Онкоурология (рак простаты, почек, мочевого пузыря)</li>
        <li>Репродуктивное здоровье и мужское бесплодие</li>
        <li>Урогинекология (в том числе недержание мочи)</li>
        <li>Эндоскопическая и лапароскопическая урология</li>
        <li>Диагностика и лечение мочекаменной болезни</li>
        <li>Психосексуальные расстройства</li>
        <li>Реабилитация и паллиативная помощь в урологии</li>
      </ul>
      <p>
        Обучение включает обязательную клиническую практику в урологических отделениях, участие в оперативных вмешательствах, симуляционные
        тренинги и стажировки в международных медицинских учреждениях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Уролог в государственных и частных клиниках</li>
        <li>Андролог — специалист по мужскому репродуктивному здоровью</li>
        <li>Хирург-уролог, работающий с малоинвазивными и роботизированными</li>
        <li>Специалист в области онкоурологии</li>
        <li>Консультант в центрах мужского здоровья</li>
        <li>Научный сотрудник или преподаватель</li>
      </ul>
      <h2>Средний доход специалистов в Европе:</h2>
      <p>
        от <strong>€65,000 до €115,000 в год,</strong> в зависимости от страны, уровня квалификации и специализации
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с возможностью трудоустройства в ЕС</li>
        <li>Дистанционный формат обучения без потери качества</li>
        <li>Углубленная клиническая и операционная подготовка</li>
        <li>Курсы роботизированной и лапароскопической хирургии</li>
        <li>Преподаватели с многолетним опытом в международной урологии</li>
        <li>Возможность стажировок в клиниках Германии, Австрии, Чехии и других стран ЕС</li>
        <li>Помощь в аккредитации диплома и выходе на европейский рынок труда</li>
      </ul>
      <p>
        <strong>
          Урология — это больше, чем медицина. Это забота о самых интимных аспектах здоровья с точностью, уважением и профессионализмом.
        </strong>
      </p>
      <h2>Как поступить?</h2>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Урология — точная диагностика и хирургия с заботой о качестве жизни
    Урология — это важнейшее клиническое направление, которое занимается диагностикой, лечением и профилактикой заболеваний мочевыделительной системы у мужчин и женщин, а также патологий мужской репродуктивной системы. Эта специальность сочетает в себе терапевтические, хирургические и высокотехнологичные подходы к лечению пациентов.
    Обучение по направлению «Урология» ориентировано на подготовку врачей, владеющих современными методами диагностики, малоинвазивными и эндоскопическими техниками, а также навыками ведения пациентов с хроническими и острыми заболеваниями почек, мочевого пузыря, предстательной железы и половых органов.

    Что вы будете изучать?
    • Анатомия и физиология мочеполовой системы
    • Урологические инфекции и воспалительные заболевания
    • Онкоурология (рак простаты, почек, мочевого пузыря)
    • Репродуктивное здоровье и мужское бесплодие
    • Урогинекология (в том числе недержание мочи)
    • Эндоскопическая и лапароскопическая урология
    • Диагностика и лечение мочекаменной болезни
    • Психосексуальные расстройства
    • Реабилитация и паллиативная помощь в урологии
    Обучение включает обязательную клиническую практику в урологических отделениях, участие в оперативных вмешательствах, симуляционные тренинги и стажировки в международных медицинских учреждениях.

    Кем можно работать после окончания?
    • Уролог в государственных и частных клиниках
    • Андролог — специалист по мужскому репродуктивному здоровью
    • Хирург-уролог, работающий с малоинвазивными и роботизированными методиками
    • Специалист в области онкоурологии
    • Консультант в центрах мужского здоровья
    • Научный сотрудник или преподаватель

    Средний доход специалистов в Европе:
    от €65,000 до €115,000 в год, в зависимости от страны, уровня квалификации и специализации

    Почему выбирают нас?
    • Европейский диплом с возможностью трудоустройства в ЕС
    • Дистанционный формат обучения без потери качества
    • Углубленная клиническая и операционная подготовка
    • Курсы роботизированной и лапароскопической хирургии
    • Преподаватели с многолетним опытом в международной урологии
    • Возможность стажировок в клиниках Германии, Австрии, Чехии и других стран ЕС
    • Помощь в аккредитации диплома и выходе на европейский рынок труда

    Урология — это больше, чем медицина. Это забота о самых интимных аспектах здоровья с точностью, уважением и профессионализмом.

    Как поступить?
  `,
};
